













import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    subtitle: {
      type: String,
      default: '',
      required: true
    }
  },
  setup() {
    return {};
  }
});
